export default {
  cirurgiao: 1,
  auxiliar1: 0.3,
  auxiliar2: 0.2,
  auxiliar3: 0.2,
  auxiliar4: 0.2,
  instrumentador: 0.1,
}
